import React from 'react';
import { SideSheet, SideSheetProps } from 'pounceV2';
import SetLogStreamTypeSidesheetContentV3, {
  SetLogStreamTypeSidesheetContentProps,
} from './SetLogStreamTypeSidesheetContentV3';

export type SetLogStreamTypeSidesheetProps = SetLogStreamTypeSidesheetContentProps & SideSheetProps;

const SetLogStreamTypeSidesheetV3 = ({
  streamType,
  jsonArrayEnvelopeField,
  xmlRootElement,
  retainEnvelopeFields,
  onSave,
  excludeCloudwatch,
  streamTypes,
  withEnvelopeField,
  withXmlRootElement,
  open,
  onClose,
}: SetLogStreamTypeSidesheetProps) => {
  return (
    <SideSheet
      aria-label="Set Log Stream Type"
      width="60%"
      containerProps={{
        p: 0,
      }}
      hideDismissIcon
      open={open}
      onClose={onClose}
    >
      {open && (
        <SetLogStreamTypeSidesheetContentV3
          streamType={streamType}
          jsonArrayEnvelopeField={jsonArrayEnvelopeField}
          xmlRootElement={xmlRootElement}
          retainEnvelopeFields={retainEnvelopeFields}
          onSave={onSave}
          withEnvelopeField={withEnvelopeField}
          withXmlRootElement={withXmlRootElement}
          excludeCloudwatch={excludeCloudwatch}
          streamTypes={streamTypes}
          onClose={onClose}
        />
      )}
    </SideSheet>
  );
};

export default SetLogStreamTypeSidesheetV3;
